import { AccountNavigationView } from '@playbooks/components/account/account-navigation-view';
import { useIntercom } from '@playbooks/contexts';

const AccountDropSupport = ({ target, onPrev }) => {
	const intercom = useIntercom();
	return (
		<AccountNavigationView
			title='Support'
			target={target}
			onBack={onPrev}
			items={[
				{
					icon: 'tower-broadcast',
					href: 'https://playbooks.betteruptime.com',
					label: 'Status',
					external: true,
				},
				{ icon: 'life-ring', label: 'Live Chat', onClick: () => intercom.toggle() },
				{ icon: 'headset', href: '/contact', label: 'Contact us' },
				{ icon: 'file-contract', href: '/terms', label: 'Legal' },
			]}
		/>
	);
};
export { AccountDropSupport };
